import { styled } from '@linaria/react';
import type { AgentMinerSession } from '../../../../api/agent-miner-client/agent-miner-client.type';
import { inkDark } from '../../../../styles/design-tokens';
import { AGENT_SOURCES_LABELS } from '../../../agentic-process/agentic-process.type';
import { AgentSourceIcon } from '../../shared/agent-source-icon';

type SourceCellProps = {
  session: AgentMinerSession;
};

export function SourceCell({ session }: SourceCellProps) {
  const label = AGENT_SOURCES_LABELS[session.source] ?? session.source;
  return (
    <Wrapper>
      <AgentSourceIcon source={session.source} size={18} />
      <Label title={label}>{label}</Label>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

const Label = styled.span`
  font: 500 12px/1.2 'Figtree', sans-serif;
  color: ${inkDark};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;
